import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { WebStorage } from '../storage/web.storage';

@Injectable({
    providedIn: 'root',
})
export class ParentAuthGuard implements CanActivate, CanActivateChild {
    constructor(private router: Router, private storage: WebStorage) {}

    // changed: validate only by role (refTable) — no authority checks
    canActivate(): Observable<boolean | UrlTree> {
        return new Observable<boolean | UrlTree>((observer) => {
            const interval = setInterval(() => {
                const user = this.storage.getUserData();
                if (user) {
                    clearInterval(interval);
                    const refTable = (user?.refTable || '').toString().trim().toLowerCase();
                    const isParentRole = refTable === 'parent' || refTable === 'guardian';

                    observer.next(isParentRole ? true : this.router.parseUrl('/notfound'));
                    observer.complete();
                }
            }, 100);

            // fallback timeout
            setTimeout(() => {
                clearInterval(interval);
                observer.next(this.router.parseUrl('/notfound'));
                observer.complete();
            }, 5000);
        });
    }

    canActivateChild(): Observable<boolean | UrlTree> {
        return this.canActivate();
    }
}
